
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import AlerteForm from '@/components/forms/AlerteForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const alerteModule = namespace('alerte')

@Component({
  components: {
    BaseCardContainer,
    AlerteForm
  }
})
export default class ProspectAlerteUpdate extends Vue {
  @alerteModule.Getter('alerteGetter') alerte: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @alerteModule.Action('getAlerteByIdAction') getAlerteById: any
  @alerteModule.Action('updateAlerteAction') updateAlerte: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    this.getAlerteById(this.$route.params.alerteId)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.alerteId', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getAlerteById(newVal)
  }

  onSubmit(data: any) {
    this.updateAlerte({
      id: this.$route.params.alerteId,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectAlerte', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.push({name: 'prospectAlerte', params: {id: this.$route.params.id}})
  }
}
